import { SET_MODALS } from '@/store/actions/commonActions';

const initialState = {
  modals: [],
};

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MODALS:
      return { ...state, modals: action.modals };
    default:
      return state;
  }
};

export default commonReducer;
